// extracted by mini-css-extract-plugin
export default {"bpTablet":"48.0625em","bpDesktop":"64.0625em","bpDesktopMedium":"85.4375em","bpDesktopLarge":"96.0625em"};